<template>
  <div class="page flex-col">
    <div class="block_3 flex-col">
        <div class="section_1 flex-row">
          <span class="text_7" style="cursor:pointer;" @click="handleJump('/home')">首页</span>
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./assets/img/757920ed6bd13f451440ad2348c7da90.webp"
          />
          <span class="text_8" style="cursor:pointer;" @click="handleReturn">服务案例</span>
          <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="./assets/img/5057d3ce9956ed573e37c9df1b140e0f.webp"
          />
          <span class="text_9">{{ data['lanhutext0'] }}</span>
        </div>
        <span class="text_10">{{ data['lanhutext0'] }}</span>
        <span class="paragraph_1">
          <div v-for="(item, index) in data['describeList']" :key="index">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item }}
          </div>
        </span>
        <div class="image-wrapper_1 flex-row">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            v-for="(item, index) in data['photoList']"
            :src="item"
            :key="index"
          />
        </div>
        <div class="image-text_1 flex-row justify-between">
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./assets/img/7210b260433122b6d794dd5bc01a3a5b.webp"
          />
          <span class="text-group_1" style="cursor:pointer;" @click="handleReturn">返回</span>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  emits: ['select'],
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    handleJump(url, data = {}) {
      if (url === this.$route.path) return;
      this.$router.push({
        path: url,
        query: data
      });
      window.scrollTo(0,0);
    },
    handleReturn() {
      this.$emit('select', 0)
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
